/**
 * Breakpoints unificados de la plataforma.
 * Fuente única de verdad para JS (hooks) y CSS (media queries).
 * MOBILE_MAX (768) coincide con las media queries existentes de
 * Header.module.css / Sidebar.module.css / BottomNav.module.css.
 */

export const BREAKPOINTS = {
  xs: 480,
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
};

/** Corte app/desktop: por debajo de este ancho, el residente ve el shell mobile de la app. */
export const MOBILE_MAX = BREAKPOINTS.md; // 768
